"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingProviderPreference = exports.PaymentsInterimBillingInterval = exports.StripePaymentStatus = exports.CompanyTypes = exports.CompanyVerificationStatus = exports.CompanyStatus = void 0;
var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus["ACTIVE"] = "active";
    CompanyStatus["BANNED"] = "banned";
    CompanyStatus["DELETED"] = "deleted";
    /** Company is terminated . Status can be changed only via Admin panel */
    CompanyStatus["TERMINATED"] = "terminated";
})(CompanyStatus = exports.CompanyStatus || (exports.CompanyStatus = {}));
var CompanyVerificationStatus;
(function (CompanyVerificationStatus) {
    CompanyVerificationStatus["PENDING_VERIFICATION"] = "pending_verification";
    CompanyVerificationStatus["REJECTED_WITH_RETRY_ALLOWED"] = "rejected_with_retry_allowed";
    CompanyVerificationStatus["STARTED_VERIFICATION"] = "started_verification";
    CompanyVerificationStatus["MANUAL_REVIEW_REQUIRED"] = "manual_review_required";
    CompanyVerificationStatus["REJECTED"] = "rejected";
    CompanyVerificationStatus["VERIFIED"] = "verified";
    /** Final rejected status can be only assigned via Admin panel */
    CompanyVerificationStatus["FINAL_REJECTED"] = "final_rejected";
})(CompanyVerificationStatus = exports.CompanyVerificationStatus || (exports.CompanyVerificationStatus = {}));
var CompanyTypes;
(function (CompanyTypes) {
    CompanyTypes["SOLE_TRADER"] = "sole_trader";
    CompanyTypes["COMPANY"] = "company";
    /** Consumer company  (for now available only for partners' merchants). These merhcnats:
     *
     * - They Can't login to the system as managed company
     * - IF isAutoIdAndBankAccountVerificationEnabledForConsumerMerchants on Partner level is true, then:
     * - ID verification is not required (Verified by default)
     * - All bank accounts are verified by default
     *
     *
     */
    CompanyTypes["CONSUMER"] = "consumer";
})(CompanyTypes = exports.CompanyTypes || (exports.CompanyTypes = {}));
var StripePaymentStatus;
(function (StripePaymentStatus) {
    StripePaymentStatus["REQUESTED"] = "requested";
    StripePaymentStatus["ENABLED"] = "enabled";
    StripePaymentStatus["DISABLED"] = "disabled";
})(StripePaymentStatus = exports.StripePaymentStatus || (exports.StripePaymentStatus = {}));
/**
 * How often to issue an interim (mid-cycle) charge for OB Payments subscriptions.
 * Used to avoid large unpaid balances accumulating before end-of-month billing.
 * null / undefined = standard monthly billing only.
 */
var PaymentsInterimBillingInterval;
(function (PaymentsInterimBillingInterval) {
    PaymentsInterimBillingInterval["DAILY"] = "daily";
    PaymentsInterimBillingInterval["WEEKLY"] = "weekly";
    PaymentsInterimBillingInterval["BIWEEKLY"] = "biweekly";
})(PaymentsInterimBillingInterval = exports.PaymentsInterimBillingInterval || (exports.PaymentsInterimBillingInterval = {}));
var BillingProviderPreference;
(function (BillingProviderPreference) {
    BillingProviderPreference["RYFT"] = "ryft";
    BillingProviderPreference["GOCARDLESS"] = "gocardless";
    BillingProviderPreference["MANUAL"] = "manual";
})(BillingProviderPreference = exports.BillingProviderPreference || (exports.BillingProviderPreference = {}));
